import type {
  ListRepoCatalogResponse,
  RepoCatalogEntry,
} from '../../../../shared/types/forgeConfig';
import type { ProjectErrorResponse } from '../../../../shared/types/projects';
import { authFetch } from './authFetch';
import { API_BASE } from './version';

async function readErr(r: Response, fallback: string): Promise<string> {
  try {
    const b = (await r.json()) as ProjectErrorResponse;
    if (b?.error?.message) return b.error.message;
  } catch {
    /* */
  }
  return fallback;
}

/**
 * List every repo attached to a project. Backs the /repos landing page and
 * the repo picker on the "new epic" form. The per-repo forge.yaml editor was
 * removed (config now lives in project settings), so this catalog lookup is
 * the only forge-config client the portal still needs.
 */
export async function fetchRepoCatalog(): Promise<RepoCatalogEntry[]> {
  const r = await authFetch(`${API_BASE}/repos/catalog`);
  if (!r.ok) throw new Error(await readErr(r, 'Failed to load repo catalog'));
  const body = (await r.json()) as ListRepoCatalogResponse;
  return body.data.repos;
}
